import React from "react";
import PropTypes from "prop-types";

import Button from "common-components/Buttons";
import Modal from "common-components/Modal/Modal";
import { replaceHashValues } from "utils/replaceHashValues";
import { ModalTitle, ModalBody, ModalFooter } from "@vds/modals";

const RepFlowModal = ({
  handleClick,
  handleCancelClick,
  notificationMethod,
  mobileNumber,
  dateOfRequest,
  modalContent,
  ...props
}) => {
  return (
    <Modal contentLabel="cancel request modal" closeModal={handleCancelClick}>
      <ModalTitle>
        <h2 style={{ marginTop: "25px", maxWidth: "545px", marginBottom: "35px" }}>
          {modalContent.Category[0].category_name}
        </h2>
      </ModalTitle>
      <ModalBody>
        <p style={{ maxWidth: "480px", marginBottom: "35px" }}>
          {modalContent.section_description ? modalContent.section_description : ""}
        </p>
        <p style={{ maxWidth: "480px", marginBottom: "35px" }}>
          {modalContent.Category[0].category_description}
        </p>
      </ModalBody>
      <ModalFooter
        buttonData={{
          primary: {
            width: "100%",
            children: modalContent.buttons[0].text,
            onClick: () => handleClick(),
          },
          close: {
            width: "100%",
            children: modalContent.buttons[1].text,
          },
        }}
      />
    </Modal>

    // <div style={{display:"flex"}}>
    // <Button style={{ width: "11.75rem", marginLeft: "10px", marginRight: "50px" }} onClick={handleClick} background={modalContent.buttons[0].type}>
    //  ayaankkkkkk
    // </Button>
    // <Button style={{ width: "11.75rem", marginLeft: "10px" }} onClick={handleCancelClick} background={modalContent.buttons[1].type}>
    //   {modalContent.buttons[1].text}
    // </Button>
    // </div>
    // </Modal>
  );
};

export default RepFlowModal;

RepFlowModal.propTypes = {
  handleClick: PropTypes.func.isRequired,
  handleCancelClick: PropTypes.func.isRequired
};
